module.exports = __webpack_public_path__ + "img/CB5E3B_FABC7A_EF965E_F4A46C-256px.bf46ba52.png";